import "./LineClear.scss";

export function LineClear() {
  return <div className="line-clear"></div>;
}
